import { Button, Form, Input, message } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signUpConfirmCode } from '../userManagementUtils';
import { Store } from '../../../store/Store';

interface emailProps {
    userMail: string;
    setIsConfirmCode: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConfirmCode = ({ userMail, setIsConfirmCode }: emailProps) => {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

    const handleConfirmCode = (values: any) => {
        setLoading(true)
        Store.isInitialized = false
        signUpConfirmCode(userMail, values.code).then((result) => {
            message.success("User confirmed successfully. Please login to continue.");
            Store.isInitialized = true
            navigate('/login');
            setIsConfirmCode(false);
        }).catch((err) => {
            Store.isInitialized = true
            message.error(err?.message || "Failed to confirm user.");
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <Form
            name="confirm_code"
            className="confirm-code-form"
            initialValues={{ remember: false }}
            onFinish={handleConfirmCode}
        >
            <Form.Item
                name="code"
                rules={[{ required: true, message: 'Please enter the confirmation code!' }]}
                className='form_input_field'
            >
                <Input size="large" placeholder="Confirmation Code*" autoComplete="off" />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" size='large' className="user_control_btn" loading={loading}>
                    Confirm Code
                </Button>
            </Form.Item>
        </Form>
    );
}

export default ConfirmCode;
